import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function InsertDeleteColumn({ action, variables, setOpenVariable, showAlert }) {
    const { t } = useTranslation();
    const [tab, setTab] = useState(action.fields.tab?.value ? action.fields.tab.value : 'insertCol');
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.INSERT-DELETE-COLUMN.';
    useEffect(() => {
        // Assign initial values
        if (!action.fields.tab) {
            action.fields.tab = { value: 'insertCol' };
        } else {
            setTab(action.fields.tab.value);
        }
        if (!action.fields.insertColumn) {
            action.fields.insertColumn = { value: '', isRequired: true };
        }
    }, [action]);
    // Handle tab change
    const handleClick = (e) => {
        let value = e.target.value;
        action.fields.tab = { value };
        if (value === 'insertCol') {
            if (action.fields.deleteColumn) {
                action.fields.deleteColumn.isRequired = false;
            }
            if (action.fields.insertColumn) {
                action.fields.insertColumn.isRequired = true;
            }
        } else {
            if (action.fields.insertColumn) {
                action.fields.insertColumn.isRequired = false;
            }
            if (action.fields.deleteColumn) {
                action.fields.deleteColumn.isRequired = true;
            } else {
                if (!action.fields.deleteColumn) {
                    action.fields.deleteColumn = { value: '', isRequired: true };
                }
            }
        }
        setTab(value);
    };
    return (
        <>
            <div className="form-element">
                <div className="form-element">
                    {t(label + 'EXCEL-SOURCE')}
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired/>
                    <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
            </div>
            <div className="form-element condition-tabs">
                <button className={`font-11 ${tab === 'insertCol' ? 'condition-active' : ''}`}
                    value="insertCol" onClick={handleClick}>
                    {t(label + 'INSERT')}
                </button>
                <button className={`font-11 ${tab === 'deleteCol' ? 'condition-active' : ''}`}
                    value="deleteCol" onClick={handleClick}>
                    {t(label + 'DELETE')}
                </button>
            </div>
            {tab === 'deleteCol' ?
                <div className="form-element">
                    <TextInput action={action} inputName="deleteColumn" variables={variables}
                        setOpenVariable={setOpenVariable} isRequired displayName={t(label + 'DELETE')} fieldType="string-columns" />
                    <em className="form-element-eg">{t(label + 'DELETE-EG')}</em>
                </div> :
                <div className="form-element">
                    <TextInput action={action} inputName="insertColumn" variables={variables}
                        setOpenVariable={setOpenVariable} isRequired displayName={t(label + 'INSERT')} fieldType="string-single-column" />
                    <em className="form-element-eg">{t(label + 'INSERT-EG')}</em>
                </div>
            }
        </>
    );
}
export default InsertDeleteColumn;